import './src/styles/global.css'
import * as React from 'react'
import MarketingThemeProvider from './src/components/MarketingThemeProvider'
import firebaseAnalyticsClient from './src/clients/firebaseAnalyticsClient'
import cookiebotClient from './src/clients/cookiebotClient'
import metaPixelClient from './src/clients/metaPixelClient'

export const wrapRootElement = ({ element }: { element: React.ReactNode }) =>
  React.createElement(MarketingThemeProvider, null, element)

let lastFirebaseTrackedHref: string | null = null
let lastMetaPixelTrackedHref: string | null = null

const trackCurrentPageViewIfAllowed = async () => {
  if (typeof window === 'undefined') {
    return
  }
  const href = window.location.href
  const pageView = {
    pathname: window.location.pathname,
    href,
    title: document.title,
  }
  if (cookiebotClient.hasStatisticsConsent() && lastFirebaseTrackedHref !== href) {
    await firebaseAnalyticsClient.trackPageView(pageView)
    lastFirebaseTrackedHref = href
  }
  if (cookiebotClient.hasMarketingConsent() && lastMetaPixelTrackedHref !== href) {
    if (metaPixelClient.trackPageView()) {
      lastMetaPixelTrackedHref = href
    }
  }
}

export const onClientEntry = async () => {
  if (cookiebotClient.isEnabled()) {
    window.addEventListener('CookiebotOnConsentReady', () => {
      void trackCurrentPageViewIfAllowed()
    })
    window.addEventListener('CookiebotOnAccept', () => {
      void trackCurrentPageViewIfAllowed()
    })
    return
  }
}

export const onRouteUpdate = async () => {
  if (typeof window === 'undefined') return

  await trackCurrentPageViewIfAllowed()
}
